import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, } from '@mui/material'
import React, { useState } from 'react'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import EditIcon from '@mui/icons-material/Edit'
import { connect } from 'react-redux'
import ConsignmentTypeModal from './ConsignmentTypeModal'
import { updateModal } from '../../../../../store/common/common_action'
import { focusElemnt, navigation2, navigation3 } from '../../../../common/helper'
import { useEffect } from 'react'
import moment from 'moment/moment'
// import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

const ConsignmentTable = (props) => {
    const { data, updateModal, tableData, propData } = props
    const { common } = data
    const { showModal, modalType, } = { ...common }
    const columnDefs = [
        { headerName: 'SN', field: "SN", headerSx: { minWidth: "30px" }, showfilter: false },
        { headerName: 'Consignment ID', field: "ConsignmentSubTypeID", headerSx: { minWidth: "121px" }, showfilter: true },
        { headerName: 'Consignment Type', field: "SubType", headerSx: { minWidth: "135px" }, showfilter: true },
        { headerName: 'Default MOP', field: "DefaultMOP", headerSx: { minWidth: "118px" }, showfilter: true },
        { headerName: 'MOP Edit', field: "IsMOPEdit", headerSx: { minWidth: "85px" }, showfilter: true },
        { headerName: 'GST', field: "IsGST", headerSx: { minWidth: "85px" }, showfilter: true },
        { headerName: 'Billing Unit', field: "BillingUnitName", headerSx: { minWidth: "90px" }, showfilter: true },
        { headerName: 'Weight Charged', field: "WeightCharged", headerSx: { minWidth: "105px" }, showfilter: true },
        { headerName: 'Min Weight KG', field: "MinChargeWeight", headerSx: { minWidth: "98px" }, showfilter: true },
        { headerName: 'Default Rate', field: "Rate", headerSx: { minWidth: "87px" }, showfilter: true },
        { headerName: 'Modified By', field: "ModifiedUser", headerSx: { minWidth: "112px" }, showfilter: true },
        { headerName: 'Modified Date & Time', field: "ModifiedDateTime", headerSx: { minWidth: "140px" }, showfilter: false },
        { headerName: 'Status', field: "IsActive", headerSx: { minWidth: "35px" }, showfilter: false },
        // { headerName: 'Rate', field:"SN",headerSx: { minWidth: "80px" }, showfilter: false },
        { headerName: 'Edit', field: "Btn", headerSx: { minWidth: "35px" }, showfilter: false },
    ]
    const updateConsignment = { id: 'UpdateConsignmentType', lrListLabel: 'Create New Consignment Type popup modal', isSaved: false }
    const [showTableData, setShowTableData] = useState([])
    const [editableData, setEditableData] = useState("")
    const [searchData, setSearchData] = useState({
        ConsignmentSubTypeID: "",SubType: "",DefaultMOP:"",IsMOPEdit:"",IsGST:"",
        BillingUnitName:"",WeightCharged:"",MinChargeWeight:"",Rate:"",ModifiedUser:""
    })
    useEffect(() => {
        let fiterData = tableData?.filter((val) =>
            (searchData.SubType === "" || val.SubType.toLocaleLowerCase().includes(searchData.SubType.toLocaleLowerCase())) &&
            (searchData.ConsignmentSubTypeID === "" || val.ConsignmentSubTypeID.toString().includes(searchData.ConsignmentSubTypeID.toString().toLocaleLowerCase())) &&
            (searchData.DefaultMOP === "" || val.DefaultMOP.toLocaleLowerCase().includes(searchData.DefaultMOP.toLocaleLowerCase())) &&
            (searchData.IsMOPEdit === "" || val.IsMOPEdit.toLocaleLowerCase().includes(searchData.IsMOPEdit.toLocaleLowerCase())) &&
            (searchData.IsGST === "" || val.IsGST.toLocaleLowerCase().includes(searchData.IsGST.toLocaleLowerCase())) &&
            (searchData.BillingUnitName === "" || val.BillingUnitName.toLocaleLowerCase().includes(searchData.BillingUnitName.toLocaleLowerCase())) &&
            (searchData.WeightCharged === "" || val.WeightCharged.toLocaleLowerCase().includes(searchData.WeightCharged.toLocaleLowerCase())) &&
            (searchData.MinChargeWeight === "" || val.MinChargeWeight.toString().includes(searchData.MinChargeWeight.toString()))&& 
            (searchData.Rate === "" || val.Rate.toString().includes(searchData.Rate.toString())) && 
            (searchData.ModifiedUser === "" || val.ModifiedUser.toLocaleLowerCase().includes(searchData.ModifiedUser.toLocaleLowerCase())))
        setShowTableData(fiterData)
    }, [searchData])

    useEffect(() => {
        if (tableData?.length > 0) {
            const data=tableData?.map((val)=>({...val,DefaultMOP:val.DefaultMOP==""?"No Default MOP":val.DefaultMOP}))
            setShowTableData(data || [])

        } else {
            setShowTableData([])
        }
    }, [tableData])
    const ConsTypeModal = () => {
        return <ConsignmentTypeModal isUpdate={true} propData={propData} editData={editableData} />
    }
    const keyboardNavigation = (event, prevId, nextId) => {
        if (event.key === 'Escape') {
            focusElemnt(prevId)
        }
        if (event.key === 'Enter') {
            focusElemnt(nextId)
        }
    }
    const handleSearchData = (event, field) => {
        setSearchData({ ...searchData, [field]: event.target.value })
    }
    const InsideRowContent = ({ item, index }) => {
        return (
            <TableRow key={`DR-${index}`}>
                <TableCell style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#666', }}>{index + 1}</TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.ConsignmentSubTypeID}</TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.SubType}</TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.DefaultMOP}</TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.IsMOPEdit}</TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.IsGST}</TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.BillingUnitName}</TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.WeightCharged}</TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#666',paddingRight:"30px !important" }}>{item.MinChargeWeight}</TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#666',paddingRight:"30px !important" }}>{item.Rate}</TableCell>
                {/* <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', maxWidth: '112px' }}>
                    <Tooltip title={"Kirtan Pandya Kirtan Pandya Kirtan Pandya"} placement="top-start">
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                            Kirtan Pandya Kirtan Pandya Kirtan Pandya
                        </span>
                    </Tooltip>
                </TableCell> */}
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', maxWidth: '106px' }}>
                    <Tooltip
                        title={item.ModifiedUser}
                        PopperProps={{
                            sx: {
                                '& .MuiTooltip-tooltip': {
                                    backgroundColor: '#DAEDFE', color: '#000', minHeight: '26px', display: 'flex', fontWeight: '400',
                                    alignItems: 'center', marginTop: '5px !important', fontSize: '12px',
                                },
                            },
                        }} placement="bottom-start"
                    >
                        <span onMouseOver={(e) => e.currentTarget.style.color = '#0086FF'} onMouseOut={(e) => e.currentTarget.style.color = '#444'} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
                            {item.ModifiedUser}
                        </span>
                    </Tooltip>
                </TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{moment(item.ModifiedDateTime).format("HH:mm, DD-MMM-YY")} </TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>
                    <Checkbox
                        checked={item.IsActive === 1}
                        // inputProps={{ 'aria-label': 'controlled' }}
                        sx={{ padding: "0", borderRadius: "0" }}
                    />
                </TableCell>
                {/* <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>
                    <span
                        style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold' }}
                    // onClick={() => onClick('cancelEdit', item)}
                    >
                        <CurrencyRupeeIcon sx={{ marginRight: '3px' }} />
                        Rate
                    </span>
                </TableCell> */}
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', cursor:"pointer" }}>
                    <span
                        id={`Edit-${index}`} tabIndex={0}
                        style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold' }}
                        onClick={() => { setEditableData(item); updateModal(true, "UpdateConsignmentType") }}
                        onKeyDown={(e) => navigation3(e, showTableData.length === index + 1 ? "index-1" : `Edit-${index + 1}`, index === 0 ? `index-10` : `Edit-${index - 1}`, () => { setEditableData(item); updateModal(true, "UpdateConsignmentType") })}
                    >
                        <EditIcon sx={{ marginRight: '3px' }} />
                        Edit
                    </span>
                </TableCell>

            </TableRow>
        )
    }
    return (
        <>
            <TableContainer component={Paper} className='scrollBlue' style={{ maxHeight: '65vh', marginBottom: "5px" }} >
                <Table stickyHeader size="small" aria-label="a dense table" sx={{
                    '& .MuiTableCell-root': {
                        padding: '10px 8px !important'
                    }
                }}>
                    <TableHead style={{ position: `sticky`, top: `0`, zIndex: "2" }}>
                        <TableRow>
                            {columnDefs.map((col, index) =>
                                <TableCell key={`TH-${index}`} style={{ ...col.headerSx, backgroundColor: '#DAEDFE', minHeight: '36px', fontSize: '12px', fontWeight: '600', color: '#444' }}>{col.headerName}</TableCell>
                            )}
                        </TableRow>
                        <TableRow>
                            {columnDefs.map((col, index) => col.showfilter ?
                                <TableCell key={`FTH-${index}`}>
                                    <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                        <input
                                            id={`index-${index}`}
                                            className="field"
                                            name="cancelSearchInput"
                                            style={{ width: '100%' }}
                                            placeholder="Contains"
                                            onChange={(e) => handleSearchData(e, col.field)}
                                            // onKeyDown={(e) => navigation2(e, `index-${index - 1}`,`index-${index + 1}`)}
                                            onKeyDown={(e) => keyboardNavigation(e, index === 1 ? `Edit-${showTableData?.length - 1}` : `index-${index - 1}`, index === 10 ? 'Edit-0' : `index-${index + 1}`)}
                                        />
                                        <FilterAltIcon />
                                    </div>
                                </TableCell>
                                : <TableCell></TableCell>)}
                        </TableRow>
                    </TableHead>
                    {showTableData?.length <= 0 ? (
                        <>
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={14}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginTop: '20px',
                                                marginBottom: '20px',
                                                color: 'red',
                                                fontSize: '14px',
                                            }}
                                        >
                                            <span>No results found. Please refine your search parameters and search again.</span>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </>
                    ) : showTableData.length > 0 ? (
                        <TableBody className="filter-data-row-BorderNone" sx={{ border: "none !important" }}>
                            {showTableData?.sort((a,b)=>a.SubType.localeCompare(b.SubType))?.map((item, index) => (

                                <InsideRowContent item={item} index={index} key={index} />
                            ))}
                        </TableBody>
                    ) : (
                        ''
                    )}
                </Table>
            </TableContainer>
            {showModal && [updateConsignment.id].includes(modalType) && ConsTypeModal(updateConsignment.id)}
        </>
    )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsignmentTable)